"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ContentGroup = _interopRequireDefault(require("./ContentGroup"));

var _immutable = require("immutable");

var _constants = require("../../lib/constants");

var DEFAULTS = {
  data: (0, _immutable.List)(),
  status: _constants.RequestStatus.UNINITIALIZED
};

var ContentGroups = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(ContentGroups, _Record);

  function ContentGroups() {
    (0, _classCallCheck2.default)(this, ContentGroups);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentGroups).apply(this, arguments));
  }

  (0, _createClass2.default)(ContentGroups, null, [{
    key: "fromJS",
    value: function fromJS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return new ContentGroups({
        data: (0, _immutable.List)(data.map(_ContentGroup.default.fromJS)),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return ContentGroups;
}((0, _immutable.Record)(DEFAULTS));

exports.default = ContentGroups;
module.exports = exports.default;